module.exports = __webpack_public_path__ + "img/CustomerInfo.ef729183.svg";